import React from 'react';
import { Activity, HelpCircle } from 'lucide-react';

/**
 * Компонент с расширенными параметрами для расчета метаболизма
 */
const AdvancedParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  activityLevels
}) => {
  return (
    <div className="mt-6 p-4 bg-gray-50 dark:bg-gray-800/50 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Activity className="w-5 h-5 mr-2 text-indigo-500" />
        Уровень физической активности
      </h3>
      
      <div className="mb-4 p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start">
          <HelpCircle className="w-5 h-5 text-blue-500 mr-3 mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              Зачем это нужно?
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              Уровень активности необходим для расчета вашего ежедневного расхода энергии (TDEE).
              Эта информация поможет определить, сколько калорий необходимо потреблять для
              поддержания, снижения или набора веса.
            </p>
          </div>
        </div>
      </div>
      
      <div>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
          Выберите вариант, наиболее соответствующий вашему образу жизни:
        </p>
        
        <div className="grid grid-cols-1 gap-3">
          {activityLevels.map((level) => (
            <label 
              key={level.id} 
              className={`flex items-start p-3 border rounded-lg ${
                formData.activityLevel === level.id
                  ? 'border-emerald-300 bg-emerald-50 dark:border-emerald-700 dark:bg-emerald-900/20'
                  : 'border-gray-200 dark:border-gray-700'
              } hover:bg-gray-50 dark:hover:bg-gray-800/50 cursor-pointer transition-colors`}
            >
              <input
                type="radio"
                name="activityLevel"
                value={level.id}
                checked={formData.activityLevel === level.id}
                onChange={handleInputChange}
                className="form-radio mt-1"
              />
              <div className="ml-3">
                <span className="block text-sm font-medium text-gray-900 dark:text-white">
                  {level.name}
                </span>
                <span className="text-xs text-gray-500 dark:text-gray-400">
                  {level.description}
                </span>
              </div>
            </label>
          ))}
        </div>
      </div>
      
      <div className="mt-4 flex items-center justify-between text-sm">
        <span className="text-gray-600 dark:text-gray-400">Коэффициент активности:</span>
        <span className="font-medium text-emerald-600 dark:text-emerald-400">
          {activityLevels.find(level => level.id === formData.activityLevel)?.factor || "1.55"}×
        </span>
      </div>
    </div>
  );
};

export default AdvancedParametersSection;